import React, { useState, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import { Button } from '@mui/material';
import ReviewForm from '../components/ReviewForm';
import ReviewSummary from '../components/ReviewSummary';

function AdvisorReviews({ advisorId, canReview, hasUserReview, reviews = [] }) {
  const { authState } = useContext(AuthContext);
  const [showReviewForm, setShowReviewForm] = useState(false);

  const reviewButtonText = canReview
    ? hasUserReview
      ? 'Edit My Review'
      : 'Leave a Review'
    : authState.isAuthorized
    ? 'You cannot review advisors from other schools'
    : 'Sign In to Leave A Review';

  if (!advisorId) return null;

  return (
    <div className="page-container">
      {showReviewForm ? (
        <ReviewForm
          advisorId={advisorId}
          onReviewSubmit={() => setShowReviewForm(false)}
        />
      ) : (
        <>
          {canReview ? (
            <Button variant="contained" onClick={() => setShowReviewForm(true)}>
              {reviewButtonText}
            </Button>
          ) : (
            <span>{reviewButtonText}</span>
          )}
          <ReviewSummary reviewData={reviews} />
        </>
      )}
    </div>
  );
}

export default AdvisorReviews;
